import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/titan.css';
import './styles/app.css';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import axios from 'axios';
import { clearSession } from './utils/session';

// Si el servidor rechaza la sesión (token caducado o inválido), se vuelve a la
// pantalla de entrar en vez de dejar al cliente con la app vacía.
let saliendo = false;
axios.interceptors.response.use(
  (respuesta) => respuesta,
  async (error) => {
    const estado = error?.response?.status;
    const mensaje = String(error?.response?.data?.message || '');
    const url = String(error?.config?.url || '');
    if (estado === 401 && /token/i.test(mensaje) && !url.includes('/users/login') && !saliendo) {
      saliendo = true;
      await clearSession();
      try {
        localStorage.removeItem('token');
      } catch {}
      window.location.replace('/?sesion=caducada');
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
